export function getNextAudioIndex(currentIndex: number, length: number) {
  return currentIndex + 1 < length ? currentIndex + 1 : null;
}

export function getAudioPositionKey(projectId: string, sceneIndex: number) {
  return `storyweave:audio-position:${projectId}:${sceneIndex}`;
}

type PositionStorage = Pick<Storage, 'getItem' | 'setItem'>;

export function readSavedAudioPosition(storage: PositionStorage, key: string) {
  const value = Number(storage.getItem(key));
  return Number.isFinite(value) && value > 0 ? value : 0;
}

export function saveAudioPosition(storage: PositionStorage, key: string, value: number) {
  if (Number.isFinite(value) && value >= 0) storage.setItem(key, String(value));
}
